export enum ListType {
	WISHLIST = 'wishlist',
	JOURNEY_EVALUATE = 'journey_evaluate',
	JOURNEY_APPLY = 'journey_apply',
}
